import React, { useEffect, useState } from "react"
import * as S from "./full-screen-menu.styles"

import data from "../header.json"
import Instagram from "../../../assets/icons/instagram.svg"

const FullScreenMenu = () => {
  const [activeRoute, setActiveRoute] = useState("")

  useEffect(() => {
    setActiveRoute(window.location.pathname)
  })

  return (
    <S.Wrapper>
      <S.ItemsWrapper>
        <div>
          {data.items.map((item, index) => (
            <S.Item
              key={index}
              url={item.url}
              className={activeRoute === item.url ? "activeRoute" : ""}
            >
              {item.title}
            </S.Item>
          ))}
        </div>
        <S.Description>
          <h2>{data.restaurant.name}</h2>
          <a href={`tel:'${data.restaurant.phone}`} className="phone">
            {data.restaurant.phone}
          </a>
          <p className="address">
            {data.restaurant.address} <br />
            <span>{data.restaurant.city}</span>
          </p>
          <a
            className="social-media"
            href="https://www.instagram.com/jpacexhalftimepizza/"
            target="_blank"
          >
            <p>{data.restaurant.socialMedia}</p>
            <Instagram />
          </a>
        </S.Description>
      </S.ItemsWrapper>
    </S.Wrapper>
  )
}

export default FullScreenMenu
